import {
  Box,
  BoxProps,
  Button,
  ButtonProps,
  styled,
  Typography,
  TypographyProps
} from '@mui/material'
import { forwardRef } from 'react'
import { themeUtils } from 'styles/theme'

export const OverflowingBox = styled(
  ({ expanded, ...props }: BoxProps & { expanded: boolean }) => (
    <Box {...props} sx={props.sx} />
  )
)`
  position: ${({ expanded }) => (expanded ? 'relative' : 'absolute')};
  bottom: 0;
  right: 0;
  background: ${({ expanded }) =>
    expanded
      ? 'none'
      : 'linear-gradient(270deg, #F8F8F8 91.56%, rgba(255, 255, 255, 0) 112.99%)'};
  padding-left: ${({ expanded }) => (expanded ? 0 : '20px')};
  display: flex;
  align-items: flex-end;
  pointer-events: none;
`

export const OverflowingButton = styled((props: ButtonProps) => (
  <Button {...props} sx={props.sx} />
))`
  line-height: 1.5;
  font-size: 1rem;
  padding: 0;
  min-width: auto;
  color: ${({ theme }) => theme.palette.text.secondary};
  pointer-events: auto;
  background: none;
  &:hover {
    background: none;
    color: ${({ theme }) => theme.palette.text.primary};
  }
  ${themeUtils.maxWidth.md} {
    font-size: 14px;
    line-height: 20px;
  }
`

const LocalizedTextComponent = forwardRef<
  HTMLSpanElement,
  TypographyProps & { expanded: boolean }
>(({ expanded, ...props }, ref) => (
  <Typography ref={ref} {...props} sx={props.sx} component="span" />
))
LocalizedTextComponent.displayName = 'LocalizedText'

export const LocalizedText = styled(LocalizedTextComponent)`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ expanded }) => (expanded ? 'none' : 2)};
  white-space: ${({ expanded }) => (expanded ? 'normal' : 'initial')};
  color: ${({ theme }) => theme.palette.text.primary};
`
